<template>
  <a-layout class="layout-container">
    <Header class="fixed-header" :title="title" />

    <a-layout-content class="main-content">

      <div class="fix-menu">
        <!-- 更新记录查看 -->
        <div class="fix-menu-item" @click="handleNavClick('1')">
          <div class="fix-menu-icon">
            <ContainerOutlined style="color: #fff;" />
          </div>
        </div>
        <!-- 锁屏 -->
        <div class="fix-menu-item" @click="handleNavClick('2')">
          <div class="fix-menu-icon">
            <LockOutlined style="color: #fff;" />
          </div>
        </div>
        <!-- 平台通知 -->
        <div class="fix-menu-item" @click="handleNavClick('3')">
          <div class="fix-menu-icon">
            <BellOutlined style="color: #fff;" />
          </div>
        </div>

        <div class="fix-menu-item" @click="toggleFullScreen">
          <div class="fix-menu-icon" v-if="!isFullscreen">
            <!-- <img :src="require('@/assets/image/nav/icon-d.png')" alt=""> -->
            <ExpandOutlined style="color: #fff;" />
          </div>
          <div class="fix-menu-icon" v-else>
            <!-- <img :src="require('@/assets/image/nav/icon-x.png')" alt=""> -->
            <CompressOutlined style="color: #fff;" />
          </div>
        </div>

        <a-dropdown>
          <div class=" left-user" @click.prevent>
            <div class="role">
              {{ userInfo.realName || '未知用户' }}
            </div>
            <img :src="userInfo.avatar || require('@/assets/image/user.png')" class="avatar" alt="avatar" />

          </div>

          <template #overlay>
            <a-menu style="width:100px">
              <a-menu-item key="profile" @click="showProfile">
                <span>个人信息</span>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="logout" @click="handleLogout">
                <span>退出登录</span>
              </a-menu-item>
            </a-menu>

          </template>
        </a-dropdown>

      </div>

      <div class="fixed-tags">
        <tags-view />
      </div>

      <div class="content-wrapper">
        <router-view v-slot="{ Component }">
          <!-- duration 与 .fade-* 的 0.3s 对齐：即使旧页面离场回调没触发，也会按计时器放行新页面，避免 out-in 卡住导致白屏 -->
          <transition name="fade" mode="out-in" :duration="{ enter: 300, leave: 300 }">
            <keep-alive :include="cachedViews">
              <component :is="Component" />
            </keep-alive>
          </transition>
        </router-view>
      </div>

    </a-layout-content>

    <!-- 更新记录抽屉 -->
    <a-drawer v-model:visible="updateLogVisible" title="更新记录" width="600" placement="right" :closable="true"
      @close="handleUpdateLogCancel">
      <div class="update-log">
        <a-timeline>
          <a-timeline-item v-for="(log, index) in updateLogs" :key="index">
            <template #dot>
              <ClockCircleOutlined style="fontSize: 16px" />
            </template>
            <div class="log-item">
              <div class="log-title">{{ log.version }}</div>
              <div class="log-time">{{ log.time }}</div>
              <div class="log-content">{{ log.content }}</div>
            </div>
          </a-timeline-item>
        </a-timeline>
      </div>
    </a-drawer>

    <!-- 平台通知抽屉 -->
    <a-drawer v-model:visible="noticeVisible" title="平台通知" width="500" placement="right" :closable="true"
      @close="handleNoticeCancel">
      <div class="notice-list">
        <a-list :data-source="notices">
          <template #renderItem="{ item }">
            <a-list-item>
              <a-list-item-meta>
                <template #title>
                  <span>{{ item.title }}</span>
                </template>
                <template #description>
                  <span>{{ item.time }}</span>
                </template>
              </a-list-item-meta>
              <div class="notice-content">{{ item.content }}</div>
            </a-list-item>
          </template>
        </a-list>
      </div>
    </a-drawer>


    <div class="custom-slide-panel" :class="{ 'panel-visible': profileVisible }">
      <div class="panel-header">
        <div class="panel-title">个人信息</div>
        <div class="panel-close" @click="handleProfileCancel">
          <a-button type="text">
            <template #icon><close-outlined /></template>
          </a-button>
        </div>
      </div>
      <div class="panel-content">
        <div class="profile-container">
          <a-row :gutter="24">
            <a-col :span="24">
              <div class="settings-card">
                <a-tabs v-model:activeKey="activeTab">
                  <a-tab-pane key="basic" tab="基本信息">
                    <a-form ref="basicFormRef" :model="formData" :rules="basicRules" :label-col="{ span: 4 }"
                      :wrapper-col="{ span: 16 }">
                      <a-form-item label="用户名" required>
                        <span class="user-info"> {{ formData.username }}<a class="tips">不可更改</a></span>
                      </a-form-item>
                      <a-form-item label="手机">
                        <a-input v-model:value="formData.phone" style="width:200px" />
                      </a-form-item>
                      <a-form-item label="邮箱">
                        <a-input v-model:value="formData.email" style="width:200px" />
                      </a-form-item>
                      <a-form-item label="真实名称" required>
                        <a-input v-model:value="formData.realName" style="width:200px" />
                      </a-form-item>
                      <a-form-item :wrapper-col="{ offset: 4 }">
                        <a-button type="primary" size="large" @click="handleSave">保存</a-button>
                      </a-form-item>
                    </a-form>
                  </a-tab-pane>

                  <a-tab-pane key="security" tab="安全设置">
                    <a-form ref="passwordFormRef" :model="passwordForm" :rules="passwordRules" :label-col="{ span: 4 }"
                      :wrapper-col="{ span: 16 }">
                      <a-form-item label="原密码" required>
                        <a-input-password v-model:value="passwordForm.oldPassword" style="width:200px" />
                      </a-form-item>
                      <a-form-item label="新密码" required>
                        <a-input-password v-model:value="passwordForm.newPassword" style="width:200px" />
                      </a-form-item>
                      <a-form-item label="确认密码" required>
                        <a-input-password v-model:value="passwordForm.confirmPassword" style="width:200px" />
                      </a-form-item>
                      <a-form-item :wrapper-col="{ offset: 4 }">
                        <a-button type="primary" size="large" @click="confirmChangePassword">保存</a-button>
                      </a-form-item>
                    </a-form>
                  </a-tab-pane>

                </a-tabs>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <!-- 添加遮罩层 -->
    <div class="panel-mask" v-if="profileVisible" @click="handleProfileCancel"></div>
  </a-layout>
</template>

<script>
import Header from '@/components/Header/index.vue'
import TagsView from '@/components/TagsView/index.vue'
import FullScreen from '@/components/FullScreen/index.vue'
import { computed, ref, reactive, onMounted, onUnmounted } from 'vue'
import { message } from 'ant-design-vue'
import { useRouter } from 'vue-router'  // 暂时注释掉
import { ClockCircleOutlined, CloseOutlined, BellOutlined, LockOutlined, ExpandOutlined, CompressOutlined, ContainerOutlined } from '@ant-design/icons-vue'
import { logout, getUserInfo, changePassword } from '@/api/user'


import { createRequestPool, } from '@/utils/requestPool'
export default {
  name: 'Layout',
  components: {
    Header,
    TagsView,
    FullScreen,
    ClockCircleOutlined,
    CloseOutlined,
    BellOutlined,
    LockOutlined,
    ExpandOutlined,
    CompressOutlined,
    ContainerOutlined
  },
  setup() {
    const router = useRouter()  // 暂时注释掉
    const cachedViews = computed(() => {
      return ['Role']
    })
    const profileRef = ref(null)
    const userInfo = ref({})
    const activeTab = ref("basic");
    // 添加状态变量
    const updateLogVisible = ref(false)
    const profileVisible = ref(false)
    const noticeVisible = ref(false)
    const updateLogs = ref([
      {
        version: 'v1.0.0',
        time: '2024-01-20',
        content: '系统上线'
      }
    ])
    const notices = ref([
      {
        title: '系统维护通知',
        time: '2024-01-20 10:00',
        content: '系统将于本周日进行例行维护'
      }
    ])


    const POOL_LIMIT = 4

    let requestPool = createRequestPool(POOL_LIMIT)
    let abortController = new AbortController()

    // 统计接口统一配置：带取消信号 + 关闭全局错误弹窗（失败由面板自己显示"重试"）
    const reqConf = () => ({ signal: abortController.signal, silent: true })

    // 添加固定菜单点击处理方法
    const handleNavClick = (type) => {
      switch (type) {
        case '1':
          updateLogVisible.value = true
          break
        case '2': {
          localStorage.setItem('lockScreen', 'true')
          localStorage.setItem('lockPath', router.currentRoute.value.fullPath)
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
          localStorage.setItem('username', userInfo.realName || '未知用户')
          localStorage.setItem('userAvatar', userInfo.avatar || '')
          router.push('/lock')
          break
        }
        case '3':
          noticeVisible.value = true
          break
        default:
          break
      }
    }

    const handleUpdateLogCancel = () => {
      updateLogVisible.value = false
    }

    const handleNoticeCancel = () => {
      noticeVisible.value = false
    }

    const formData = reactive({
      userId: null,
      userType: null,
      username: "",
      realName: "",
      email: "",
      phone: "",
    });

    const passwordForm = reactive({
      id: null,
      roleId: null,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });

    const basicFormRef = ref(null);
    const passwordFormRef = ref(null);

    const basicRules = {
      username: [{ required: true, message: "请输入用户名" }],
      realName: [{ required: true, message: "请输入真实名称" }],
    };

    const passwordRules = {
      oldPassword: [{ required: true, message: "请输入原密码" }],
      newPassword: [{ required: true, message: "请输入新密码" }],
      confirmPassword: [{ required: true, message: "请确认新密码" }],
    };
    const title = ref('')
    // 获取用户信息
    const getUserData = async () => {
      try {
        const res = await getUserInfo()

        if (res.code === 200) {
          userInfo.value = res.data
          if (!res.data) {
            message.error('获取的用户信息为空')
            return
          }


          // 角色IEP
          if (res.data.userType == 19) {
            title.value = '特殊儿童IEP智能决策系统'
          } else if (res.data.userType == 20) {
            title.value = '资源教室智能体评估平台'
          } else if (res.data.userType == 21) {
            title.value = '孤独症谱系智能干预评估训练系统'
          } else if (res.data.userType == 22) {
            title.value = '特殊儿童课程专项评估训练系统'
          } else if (res.data.userType == 23) {
            title.value = '特殊儿童送教上门多维评估与专项训练系统'
          } else if (res.data.userType == 24) {
            title.value = '特殊儿童心理发展评估与神经适应系统'
          } else if (res.data.userType == 25) {
            title.value = '特殊儿童神经肌肉评估训练系统'
          } else if (res.data.userType == 26) {
            title.value = '特殊儿童语言脑功能与整合干预系统'
          } else {
            title.value = '特教综合康复管理云平台'
          }

          localStorage.setItem("title", title.value);
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          localStorage.setItem("role", res.data.userType);


        } else {
          message.error(res.message || '获取用户信息失败')
        }
      } catch (error) {
        message.error(`请求失败：${error.message}`)
      }
    }

    const isFullscreen = ref(false)

    const toggleFullScreen = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
      }
    }
    const showProfile = () => {
      formData.userId = userInfo.value.userId || null;
      formData.userType = userInfo.value.userType || null;
      formData.username = userInfo.value.username || userInfo.value.teacherName || '';
      formData.realName = userInfo.value.realName || '';
      formData.email = userInfo.value.email || '';
      formData.phone = userInfo.value.phone || '';
      profileVisible.value = true;
    }

    const closeProfile = () => {
      profileRef.value.visible = false
    }

    const resetRequestScope = (reason) => {
      // 取消在途请求 + 丢弃排队中的请求，避免旧区域的数据回填到新区域
      abortController.abort()
      requestPool.stop(reason)
      abortController = new AbortController()
      requestPool = createRequestPool(POOL_LIMIT)
    }
    // 退出登录
    const handleLogout = async () => {
      try {
        resetRequestScope()
        const res = await logout(reqConf())
        if (res.code === 200) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'))

          // 角色IEP
          if (userInfo.userType == 19) {
            router.push('/IEPlogin')
          } else if (userInfo.userType == 20) {
            router.push('/Classlogin')
          } else if (userInfo.userType == 21) {
            router.push('/autismLogin')
          } else if (userInfo.userType == 22) {
            router.push('/courseLogin')
          } else if (userInfo.userType == 23) {
            router.push('/visitLogin')
          } else if (userInfo.userType == 24) {
            router.push('/psycholLogin')
          } else if (userInfo.userType == 25) {
            router.push('/limbsLogin')
          } else if (userInfo.userType == 26) {
            router.push('/speechLogin')
          } else {
            router.push('/login')
          }
          // localStorage.removeItem('token')
          // localStorage.removeItem('userInfo')
          // localStorage.removeItem('userRole')
          // localStorage.removeItem('role')
          localStorage.clear();
          message.success('退出成功')
        } else {
          // 如果接口调用失败，显示错误信息
          message.error(res.message || '退出失败')
        }
      } catch (error) {
        console.error('退出登录错误：', error)
        message.error('退出失败，请稍后重试')
      }
    }

    const handleProfileCancel = () => {
      profileVisible.value = false;
    }

    // 保存基本信息
    const handleSave = async () => {
      try {
        await basicFormRef.value.validate();
        const localUserInfo = JSON.parse(localStorage.getItem("userInfo"));
        const res = await changePassword({
          id: localUserInfo.teacherId ? parseInt(localUserInfo.teacherId) : parseInt(localUserInfo.userId),
          roleId: parseInt(localUserInfo.userType) || 0,
          phone: formData.phone,
          email: formData.email,
          realName: formData.realName
        });
        if (res.code === 200) {
          // 更新成功后，同步更新 userInfo
          Object.assign(userInfo, {
            realName: formData.realName,
            email: formData.email,
            phone: formData.phone,
          });
          message.success("保存成功");
          profileVisible.value = false

        } else {
          message.error(res.msg || "保存失败");
        }
      } catch (error) {
        if (error.errorFields) {
          message.error("请填写必填项");
        } else {
          console.error("保存用户信息错误：", error);
          message.error("保存失败");
        }
      }
    };

    // 修改密码
    const confirmChangePassword = async () => {
      // 表单验证
      if (
        !passwordForm.oldPassword ||
        !passwordForm.newPassword ||
        !passwordForm.confirmPassword
      ) {
        message.error("请填写所有密码字段");
        return;
      }

      if (passwordForm.newPassword !== passwordForm.confirmPassword) {
        message.error("两次输入的密码不一致");
        return;
      }

      // 从本地存储获取用户信息
      const localUserInfo = JSON.parse(localStorage.getItem("userInfo"));
      // 检查必要参数
      if (!localUserInfo || !localUserInfo.userId) {
        message.error("用户信息不完整，请重新登录");
        return;
      }

      try {
        passwordForm.oldPassword = passwordForm.oldPassword.trim()
        passwordForm.newPassword = passwordForm.newPassword.trim()
        // let userId = localUserInfo.teacherId ? parseInt(localUserInfo.teacherId) : parseInt(localUserInfo.userId)
        const params = {
          id: localUserInfo.teacherId ? parseInt(localUserInfo.teacherId) : parseInt(localUserInfo.userId),
          roleId: parseInt(localUserInfo.userType) || 0,
          oldPassword: passwordForm.oldPassword,
          newPassword: passwordForm.newPassword,
        };
        // console.log("发送的参数1:", params); // 添加日志

        const res = await changePassword(params);
        if (res.code === 200) {
          message.success("密码修改成功");
          // 清空表单
          passwordForm.oldPassword = null;
          passwordForm.newPassword = null;
          passwordForm.confirmPassword = null;
          profileVisible.value = false; // 关闭抽屉

        } else {
          message.error(res.message || "密码修改失败");
        }
      } catch (error) {
        if (error.errorFields) {
          message.error("请填写必填项");
        } else {
          console.error("修改密码错误：", error);
          message.error("密码修改失败");
        }
      }
    };


    const handleFullscreenChange = () => {
      isFullscreen.value = !!document.fullscreenElement
    }

    onMounted(() => {
      getUserData()
      document.addEventListener('fullscreenchange', handleFullscreenChange)
    })

    onUnmounted(() => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
    })

    return {
      formData,
      passwordForm,
      activeTab,
      handleProfileCancel,
      basicFormRef,
      passwordFormRef,
      basicRules,
      passwordRules,
      handleSave,
      confirmChangePassword,
      profileVisible,
      profileRef,
      handleLogout,
      showProfile,
      closeProfile,
      isFullscreen,
      toggleFullScreen,
      getUserData,
      userInfo,
      cachedViews,
      handleNavClick,
      updateLogVisible,
      noticeVisible,
      updateLogs,
      notices,
      handleUpdateLogCancel,
      handleNoticeCancel,
      title,
    }
  }
}
</script>

<style lang="less" scoped>
.layout-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  /* 防止出现滚动条 */
  background: #fff;
  display: flex;
  flex-direction: column;

  .fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background: #fff;
  }

  .left-user {
    // max-width: 150px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 16px;
    color: #fff;
    padding-right: 10px;
    cursor: pointer;

    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      // margin-right: 10px;
      margin-left: 10px;
    }
  }

  :deep(.table-header) {
    display: flex;
    // padding-bottom: 20px;
  }

  .main-content {
    padding-top: 100px;
    min-height: calc(100vh - 100px);
    overflow-y: scroll;
    // position: relative;

    .fixed-tags {
      position: fixed;
      // top: 100px;
      left: 0;
      right: 0;
      z-index: 99;
      background: #fff;
    }

    .content-wrapper {
      padding-top: 23px;
      min-height: calc(100vh - 140px);
      overflow: hidden;
      // position: relative;
      // top: 23px;
      // min-height: 100vh;
      // overflow-y: auto;
      // height: 100vh;
      // overflow-y: scroll;
    }
  }

  .table-header {
    margin-bottom: 0px;
  }
}

.fullscreen-wrapper {
  z-index: 1000;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.1);
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
}

.tags-view-container {
  border: none;

  :deep(.ant-tabs-nav) {
    padding: 0 16px;

    .ant-tabs-tab-btn {
      color: rgba(117, 117, 117, .8);
      font-size: 12px;
    }
  }
}

.fix-menu {
  position: absolute;
  top: 10px;
  right: 0px;
  display: flex;
  align-items: center;
  /* justify-content: flex-end; */
  z-index: 999;
  position: fixed;

  .fix-menu-item {
    width: 18px;
    height: 18px;
    margin-right: 20px;
    cursor: pointer;
    padding-top: 2px;

    .fix-menu-icon {
      width: 18px;
      height: 18px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .fix-menu-item:nth-child(3) {
    margin-right: 20px;
  }
}

.update-log {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 20px;

  .log-item {
    margin-bottom: 16px;

    .log-title {
      font-weight: bold;
      margin-bottom: 4px;
    }

    .log-time {
      color: #999;
      font-size: 12px;
      margin-bottom: 8px;
    }

    .log-content {
      color: #666;
    }
  }
}

.notice-list {
  max-height: 400px;
  overflow-y: auto;

  .notice-content {
    color: #666;
    margin-top: 8px;
  }

  :deep(.ant-list-item-meta-title) {
    margin-bottom: 0;
  }

  :deep(.ant-list-item-meta-description) {
    font-size: 12px;
    color: #999;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fullscreen-button {
  cursor: pointer;
  font-size: 18px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  color: #666;

  &:hover {
    color: #1890ff;
  }
}

.fix-menu-icon {
  width: 18px;
  height: 18px;

  img {
    width: 100%;
    height: 100%;
  }
}

@media screen and (orientation: landscape) {
  .layout-container {
    width: 100vw;
    height: 100vh;
  }
}

/* 添加媒体查询，处理竖屏模式 */
@media screen and (orientation: portrait) {
  .layout-container {
    width: 100vh;
    height: 100vw;
    transform: rotate(90deg);
    transform-origin: left top;
    position: absolute;
    top: 0;
    left: 100%;
  }
}

.custom-slide-panel {
  position: fixed;
  top: 0;
  right: -600px;
  width: 600px;
  height: 100vh;
  background-color: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
}

.panel-visible {
  right: 0;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.panel-title {
  font-size: 16px;
  font-weight: 500;
}

.panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

.panel-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 999;
}

.profile-container {
  // 移除原有的 padding
  // padding: 24px;

  .settings-card {
    background: #fff;
    font-size: 18px;
    // 移除原有的 padding 和 border-radius
    // padding: 24px;
    // border-radius: 8px;
    // box-shadow: 0 2px 8px rgba(0,0,0,0.06);

    // 设置标签页标题样式
    :deep(.ant-tabs-tab) {
      font-size: 20px !important;
    }

    // 设置表单标签样式
    :deep(.ant-form-item-label > label) {
      font-size: 18px !important;
      color: #B5B5B5;
      margin-right: 10px
    }

    .user-info {
      display: flex;
      align-items: flex-end;
      font-size: 18px;

      .tips {
        font-size: 14px;
        color: #4482C0;
        margin-left: 8px;
      }
    }

    .security-items {
      .security-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        .item-info {
          .item-title {
            font-size: 16px;
            color: #333;
            margin-bottom: 4px;
          }

          .item-desc {
            color: #666;
            font-size: 14px;
          }
        }
      }
    }
  }
}


@media (min-width: 1921px) {
  .fixed-header {
    z-index: 100 !important;
    height: 160px !important;
  }

  .main-content {
    padding-top: 160px !important;
    min-height: calc(100vh - 160px) !important;
  }

  .fixed-tags {
    top: 160px !important;
  }

  .content-wrapper {
    padding-top: 35px !important;
  }
}
</style>